import React from 'react';

const HeadingSection = () => {
  return (
    <header className="mb-16 text-center max-sm:mb-10">
      <h1 className="mb-4 text-5xl font-bold text-teal-600 leading-[56px] max-sm:text-3xl max-sm:leading-10">
        The Building Blocks of Your Business.
      </h1>
      <p className="mx-auto text-base leading-6 text-gray-500 max-w-[700px] max-sm:text-sm max-sm:leading-5">
        powerful modules. One unified data layer. Discover how our
        interconnected tools digitize your entire operational lifecycle
        from the warehouse to the final sale.
      </p>
    </header>
  );
};

export default HeadingSection;
